export default __webpack_public_path__ + "assets/resizedpopularCities_4-min.c75af93f.webp";